import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { useEffect } from "react";
import ConfigurationsPathsService from "../../../../services/api/configurations/ConfigurationsPaths.service";
import { UpdatePathsConfigRequest } from "../../../../types/api/configurations.type";

const MANAGE_CONFIG_PATHS_KEY = "get-config-paths";

export const useManagePaths = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: [MANAGE_CONFIG_PATHS_KEY, configYear],
    queryFn: () => ConfigurationsPathsService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching, refetch };
};

export const useUpdateManagePaths = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ["update-manage-paths"],
    mutationFn: (result: UpdatePathsConfigRequest) =>
      ConfigurationsPathsService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_PATHS_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`error updating paths config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, mutateAsync, isPending };
};
